import React, {useState, useEffect, useRef} from "react";
import SideBar from "../SideBar/SideBar";
import "./DashBoard.css";
import postApi from "../../Api/PostApi";
import {messaging, onMessage} from '../../firebase';

function DashBoard() {
    const [neworder, setNewOrder] = useState([]);
    console.log({neworder: neworder})
    const orderStats = [
        {label: "New Orders", count: neworder, color: "#0E78C5"},
        {label: "Order in Progress", count: 0, color: "#F7B731"},
        {label: "Delivered Orders", count: 0, color: "#28a745"},
        {label: "Cancelled Orders", count: 0, color: "#dc3545"},
        {label: "Today's Orders", count: 0, color: "#6f42c1"},
    ];

    const postApi = async (url, data) => {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    };

    const getData = async () => {
        try {
            const Storagebranch = localStorage.getItem("branch");
            const formData = {
                id: 1,
                branch_id: Storagebranch,
            };
            const API = `https://q2h.in/q2h-api/api/today_order`;
            const responseJson = await postApi(API, formData);
            setNewOrder(responseJson.data.length);

        } catch (error) {
            console.error('Error fetching orders:', error);
        }
    };

    useEffect(() => {
        getData();
        // Handle foreground notifications
        const unsubscribe = onMessage(messaging, (payload) => {
            console.log('Foreground notification received:', payload);
            const {title, body} = payload.notification;
            //alert(`${title}: ${body}`);
            const audio = new Audio("/notification.mp3");
            audio.play(); // 🔊 Play sound
            audio.loop = true;
        });

        // Cleanup listener on unmount
        return () => unsubscribe();


    }, []);


    return (
        <div className="dashboard-container">
            <SideBar/>
            <div className="analytics-content menu-card-con ">
                <div className="menu-card">
                    <h2 style={{color: "black"}}>Dashboard</h2>
                    <div className="stats-grid">

                        <div className="stat-card" style={{borderLeft: '5px solid #0E78C5'}}>
                            <h3 style={{color: '#0E78C5'}}>New Orders</h3>
                            <p>{neworder}</p>
                        </div>

                        <div className="stat-card" style={{borderLeft: '5px solid #F7B731'}}>
                            <h3 style={{color: '#F7B731'}}>Order in Progress</h3>
                            <p>0</p>
                        </div>

                        <div className="stat-card" style={{borderLeft: '5px solid #28a745'}}>
                            <h3 style={{color: '#28a745'}}>Delivered Orders</h3>
                            <p>0</p>
                        </div>

                        <div className="stat-card" style={{borderLeft: '5px solid #dc3545'}}>
                            <h3 style={{color: '#dc3545'}}>Cancelled Orders</h3>
                            <p>0</p>
                        </div>

                        <div className="stat-card" style={{borderLeft: '5px solid #6f42c1'}}>
                            <h3 style={{color: '#6f42c1'}}>Today's Orders</h3>
                            <p>0</p>
                        </div>


                    </div>
                    <div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashBoard;
